/* i18n framework setup — English (default) + French, the language most
 * useful given Campusio's West Africa focus (Ghana's francophone
 * neighbors: Côte d'Ivoire, Togo, Burkina Faso). Scope is deliberately the
 * framework plus the highest-traffic surfaces (nav, auth, dashboard,
 * settings) rather than every string in all ~140 pages — see the
 * "Platform" audit round notes. Adding a page to translation later is just
 * adding its keys to both locale files and swapping its strings for t().
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/common.json";
import fr from "./locales/fr/common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { common: en }, fr: { common: fr } },
    fallbackLng: "en",
    defaultNS: "common",
    interpolation: { escapeValue: false }, // React already escapes
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "campusio_lang" },
  });

export default i18n;
